import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ErrorPage = () => (
  <div>
    <FormattedMessage id={'app.error'} />
  </div>
);

ErrorPage.propTypes = {};

